import { useTranslation } from 'react-i18next'

import { MapPinIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Divider, Text } from '@reveni-io/reveni-ui'

import { trackingTypes } from '@/LabelTrackingPage/constants'

import Details from './Details/Details'
import * as Styles from './styles'

const DestinationInfo = ({ address, portalName, isPickupPoint, type }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (!address) return null

  const isReturn = type === trackingTypes.return

  return (
    <>
      <Divider />
      <Styles.Container>
        <Text type="allCapsM" customStyles={{ textTransform: 'uppercase', color: theme.colors.grey.tone500 }}>
          {isReturn ? t('Destino') : t('Dirección destino')}
        </Text>
        {isPickupPoint && (
          <Styles.PickupPointInfo>
            <MapPinIcon weight="light" size={20} />
            <Text type="bodyMRegular">{t('Punto de recogida')}</Text>
          </Styles.PickupPointInfo>
        )}
        <Details isReturn={isReturn} portalName={portalName} address={address} />
      </Styles.Container>
    </>
  )
}

export default DestinationInfo
